import { useMutation } from '@tanstack/react-query';
import { impersonationService } from '../../services/impersonationService';
import { EndImpersonationResponse } from '../../types/Impersonation';

export const useEndImpersonation = () => {
  return useMutation<EndImpersonationResponse, Error, string>({
    mutationFn: sessionId =>
      impersonationService.endImpersonation(sessionId),
  });
};
